import { useQuery } from "@tanstack/react-query";
import { fetchNotifications } from "@/lib/services/notificationsService";

/**
 * React Query hook for fetching notifications with 1-minute polling.
 * @param enabled - Whether the query should run (default: true)
 */
export function useNotifications(enabled = true) {
    return useQuery({
        queryKey: ["notifications"],
        queryFn: () => fetchNotifications(),
        staleTime: 30 * 1000,       // 30 seconds
        refetchInterval: 60 * 1000, // Poll every 1 minute
        enabled,
    });
}
